import { useEffect, useState } from "react";
import { useAuth } from "../../../../context/AuthContext";
import InputField from "../../../../components/InputField";
import Button from "../../../../components/Button";
import api from "../../../../api/api";
import BackButton from "../../../../components/BackButton";
import LockIcon from "@mui/icons-material/Lock";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Box } from "@mui/material";
import "./MyProfile.css";
import ChangePasswordModal from "./ChangePasswordModal";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import PersonIcon from '@mui/icons-material/Person';

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 3,
  borderRadius: "8px",
};

const MyProfile = () => {
  const { user } = useAuth();
  const [profile, setProfile] = useState({
    name: "",
    email: "",
    phone_number: "",
    designation: "",
    rm_name: "",
    rm_mobile: "",
    rm_email: "",
    user_id: "",
  });

  const [showModal, setShowModal] = useState(false);

  const [newPhone, setNewPhone] = useState("");

  const [loading, setLoading] = useState(false);

  const [openPasswordModal, setOpenPasswordModal] = useState(false);

  const [loadingProfile, setLoadingProfile] = useState(true);
  const [profileError, setProfileError] = useState("");

  useEffect(() => {
    fetchProfile();
  }, []);
  
  const fetchProfile = async () => {
    try {
      setLoadingProfile(true);
      setProfileError("");
      const response = await api.get(`/user-details/${user?.user_id}`);
      const payload = response.data?.data || response.data?.profile || response.data;
      if (payload && typeof payload === "object") {
        setProfile(payload);
      } else {
        setProfileError("Profile data is empty.");
      }
    } catch (error) {
      console.log(error);
      setProfileError("Failed to load profile. Please try again later.");
    } finally {
      setLoadingProfile(false);
    }
  };

  const openModal = () => {
    setNewPhone(profile.phone_number);

    setShowModal(true);
  };

  const handleUpdatePhone = async () => {
    try {
      setLoading(true);
      await api.post("/update-user-details", {
        user_id: user?.user_id,
        phone_number: newPhone,
      });
      setProfile({
        ...profile,
        phone_number: newPhone,
      });
      setShowModal(false);
    } catch (error) {
      console.log(error);
      alert("Failed to update mobile number. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <BackButton />

      <div className="p-2">
        {loadingProfile && (
          <div className="text-center py-5">Loading profile...</div>
        )}
        {!loadingProfile && profileError && (
          <div className="alert alert-danger" role="alert">
            {profileError}
          </div>
        )}
        {!loadingProfile && !profileError && (
        <>
         {/* Profile Information */}

        <fieldset className="security-fieldset">
          <legend className="d-flex align-items-center">
    <PersonIcon fontSize="small" className="me-2 text-black" />
  Profile Information
  </legend>
 
          <div className="row">
            <div className="col-sm-6 col-md-4">
              <InputField
                label="Name"
                type="text"
                value={profile.name}
                readOnly
              />
            </div>

            <div className="col-sm-6 col-md-4">
              <InputField
                label="Email"
                type="email"
                value={profile.email}
                readOnly
              />
            </div>
            <div className="col-sm-6 col-md-4 position-relative">
              <InputField
                label="Mobile Number"
                type="text"
                value={profile.phone_number}
                readOnly
              />

              <EditIcon
                fontSize="small"
                className="edit-profile-icon"
                onClick={openModal}
              />
            </div>

            <div className="col-sm-6 col-md-4">
              <InputField
                label="Designation"
                type="text"
                value={profile.designation}
                readOnly
              />
            </div>
          </div>
        </fieldset>



        {/* Reporting Manager */}

       
           <fieldset className="security-fieldset mt-4">
  <legend className="d-flex align-items-center">
    <SupervisorAccountIcon fontSize="small" className="me-2 text-black" />
    Reporting Manager
  </legend>

          <div className="row">
            <div className="col-sm-6 col-md-4">
              <InputField
                label="Reporting Manager Name"
                type="text"
                value={profile.rm_name || ""}
                readOnly
              />
            </div>

            <div className="col-sm-6 col-md-4">
              <InputField
                label="Manager Mobile Number"
                type="text"
                value={profile.rm_mobile || ""}
                readOnly
              />
            </div>
            <div className="col-sm-6 col-md-4">
              <InputField
                label="Reporting Manager Email"
                type="text"
                value={profile.rm_email || ""}
                readOnly
              />


            </div>
          </div>
        </fieldset>

        {/* Security */}

       <fieldset className="security-fieldset">
  <legend>
    <LockIcon className="me-2" />
    Security
  </legend>

          <div className="d-flex justify-content-start">
            <Button
              variant="btn btn-primary"
              onClick={() => setOpenPasswordModal(true)}
            >
              Change Password
            </Button>
          </div>
        </fieldset>
        </>
      )}
      </div>

      {/* Update Mobile Modal */}

      <Modal open={showModal} onClose={() => setShowModal(false)}>
        <Box sx={style}>
          <div className="d-flex justify-content-between mb-3">
            <h5 className="fw-bold mb-4">Edit Mobile Number</h5>

            <CloseIcon
              // style={{ cursor: "pointer" }}
              onClick={() => setShowModal(false)}
            />
          </div>

          <InputField
            label="Edit Mobile Number"
            type="text"
            value={newPhone}
            onChange={(e) => setNewPhone(e.target.value)}

          />

          <div className="mt-3 d-flex justify-content-end">
            <Button onClick={handleUpdatePhone} disabled={loading}>
              {loading ? "Updating..." : "Update"}
            </Button>
          </div>
        </Box>
      </Modal>

      {/* Change Password Modal */}

      <ChangePasswordModal
        open={openPasswordModal}
        handleClose={() => setOpenPasswordModal(false)}
        user={profile}
      />
    </>
  );
};

export default MyProfile;